// Catálogo dos itens de menu/submenu da sidebar que podem ter sua
// visibilidade controlada por papel (role). As chaves (`key`) precisam
// bater exatamente com o campo `name` usado em cada item dentro de
// Sidebar.vue — é assim que o filtro de visibilidade encontra o item.
//
// Itens gerados dinamicamente (uma entrada por inbox conectada, por
// label criada, por time, etc.) não entram aqui individualmente — só os
// grupos estáticos que os agrupam (ex.: o grupo "Channels", não cada
// inbox dentro dele).
export const MENU_VISIBILITY_CATALOG = [
  { key: 'Kanban', label: 'Dashboard' },
  { key: 'Inbox', label: 'Caixa de Entrada' },
  {
    key: 'Conversation',
    label: 'Conversas',
    children: [
      { key: 'All', label: 'Todas' },
      { key: 'Mentions', label: 'Menções' },
      { key: 'Participating', label: 'Participando' },
      { key: 'Unattended', label: 'Não atendidas' },
      { key: 'Folders', label: 'Pastas personalizadas' },
      { key: 'Teams', label: 'Times' },
      { key: 'Channels', label: 'Canais' },
      { key: 'Labels', label: 'Etiquetas' },
    ],
  },
  {
    key: 'Captain',
    label: 'Captain (IA)',
    children: [
      { key: 'Overview', label: 'Visão geral' },
      { key: 'FAQs', label: 'FAQs' },
      { key: 'Documents', label: 'Documentos' },
      { key: 'Scenarios', label: 'Cenários' },
      { key: 'Playground', label: 'Playground' },
      { key: 'Inboxes', label: 'Caixas de entrada' },
      { key: 'Tools', label: 'Ferramentas' },
    ],
  },
  {
    key: 'Contacts',
    label: 'Contatos',
    children: [
      { key: 'All Contacts', label: 'Todos os contatos' },
      { key: 'Active', label: 'Ativos' },
      { key: 'Segments', label: 'Segmentos' },
      { key: 'Tagged With', label: 'Marcados com etiqueta' },
    ],
  },
  {
    key: 'Companies',
    label: 'Empresas',
    children: [{ key: 'All Companies', label: 'Todas as empresas' }],
  },
  {
    key: 'Reports',
    label: 'Relatórios',
    children: [
      { key: 'Report Overview', label: 'Visão geral' },
      { key: 'Report Conversation', label: 'Conversas' },
      { key: 'Reports CSAT', label: 'CSAT' },
      { key: 'Reports SLA', label: 'SLA' },
      { key: 'Reports Bot', label: 'Bot' },
    ],
  },
  {
    key: 'Campaigns',
    label: 'Campanhas',
    children: [
      { key: 'Live chat', label: 'Chat ao vivo' },
      { key: 'SMS', label: 'SMS' },
      { key: 'WhatsApp', label: 'WhatsApp' },
    ],
  },
  {
    key: 'Portals',
    label: 'Central de Ajuda',
    children: [
      { key: 'Articles', label: 'Artigos' },
      { key: 'Categories', label: 'Categorias' },
      { key: 'Locales', label: 'Idiomas' },
      { key: 'Settings', label: 'Configurações' },
    ],
  },
  {
    key: 'Settings',
    label: 'Configurações',
    children: [
      { key: 'Settings Account Settings', label: 'Conta' },
      { key: 'Settings Agents', label: 'Agentes' },
      { key: 'Settings Teams', label: 'Times' },
      { key: 'Settings Inboxes', label: 'Caixas de entrada' },
      { key: 'Settings Labels', label: 'Etiquetas' },
      { key: 'Settings Custom Attributes', label: 'Atributos personalizados' },
      { key: 'Settings Automation', label: 'Automação' },
      { key: 'Settings Agent Bots', label: 'Agent Bots' },
      { key: 'Settings Macros', label: 'Macros' },
      { key: 'Settings Canned Responses', label: 'Respostas prontas' },
      { key: 'Settings Integrations', label: 'Integrações' },
      { key: 'Settings Audit Logs', label: 'Logs de auditoria' },
      { key: 'Settings Custom Roles', label: 'Papéis personalizados' },
      { key: 'Settings Sla', label: 'SLA' },
      { key: 'Conversation Workflow', label: 'Fluxo de conversa' },
      { key: 'Settings Security', label: 'Segurança' },
      { key: 'Settings Billing', label: 'Cobrança' },
    ],
  },
];

// Chave que fica sempre restrita a Super Admins (tipo de usuário, não
// papel de conta), independente do que estiver salvo no banco — evita
// que um admin comum se tranque fora, e garante que só quem já tem
// acesso ao Super Admin Console possa mexer nessa configuração.
export const ALWAYS_SUPER_ADMIN_ONLY_KEYS = [
  'MenuVisibility',
  'Settings Branding',
  'Settings Custom Menus',
];
